export default __webpack_public_path__ + "static/media/review_next_button.e41225e5.png";